<template>
  <nav class="navbar navbar-expand-lg navbar-light" style="background: var(--primary)">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">
        <img style="height: 50px" src="http://test.blinqed.com/images/logobox.png" alt="Blinqed" />
      </a>
      <button class="btn btn-sm btn-danger float-right" @click="logout">Logout</button>
    </div>
  </nav>
  <div class="container-fluid" style="padding: 0 30% 0 30%">
    <div class="card my-3">
      <div class="card-header"><strong>Reports</strong></div>
      <div class="card-body">
        <div class="form-group">
          <label for="report-type">Report Type:</label>
          <select class="form-control" v-model="reportType">
            <option value="">-- Please select one ---</option>
            <option v-for="report in reports" :value="report.value" :key="report.id">{{ report.value }}</option>
          </select>
        </div>
        <div class="row my-2">
          <div class="col-md-6 form-group">
            <label for="start-date">Start Date:</label>
            <input class="form-control" type="date" id="start-date" name="start-date" v-model="startDate" />
          </div>
          <div class="col-md-6 form-group">
            <label for="end-date">End Date:</label>
            <input class="form-control" type="date" id="end-date" name="end-date" v-model="endDate" />
          </div>
        </div>
      </div>
      <div class="card-footer">
        <button class="btn btn-sm btn-success" @click="generateReport">Generate Report</button>
      </div>
    </div>
    <div class="card my-3">
      <div class="card-header"><strong>Dumps</strong></div>
      <div class="card-body">
        <div class="input-group mb-3">
          <label for="sligro-dump" class="form-control">Sligro Sku Dump</label>
          <button class="btn btn-outline-success" type="button" id="button-addon2" @click="dumpSligro">Download</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportService from "@services/ReportService";
import XLSX from "xlsx";

export default {
  data() {
    return {
      startDate: "",
      endDate: "",
      reportType: "",
      reports: [
        { id: 1, value: "Seller Report" },
        { id: 2, value: "Buyer Report" },
        { id: 3, value: "Order Summary Report" },
        { id: 4, value: "Order Detail Report" },
      ],
      reportLines: [],
    };
  },
  methods: {
    logout() {
      window.localStorage.clear();
      window.location.reload();
    },
    async generateReport() {
      try {
        const data = {
          startDate: this.startDate,
          endDate: this.endDate,
          reportType: this.reportType,
        };
        const res = await ReportService.generateReports(data);

        const datas = XLSX.utils.json_to_sheet(res.data);
        const wb = XLSX.utils.book_new();
        const today = Date.now();
        XLSX.utils.book_append_sheet(wb, datas, "data");
        XLSX.writeFile(wb, `${this.reportType}-${today}.xlsx`);
      } catch (error) {
        console.log(error);
      }
    },
    async dumpSligro() {
      try {
        const res = await ReportService.dumpSligro();

        const datas = XLSX.utils.json_to_sheet(res.data);
        const wb = XLSX.utils.book_new();
        const today = Date.now();
        XLSX.utils.book_append_sheet(wb, datas, "data");
        XLSX.writeFile(wb, `Sligro-sku-dump-${today}.xlsx`);
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
